module.exports = __webpack_public_path__ + "assets/icon-sparkles-component.e1cae502.svg";